/* ==========================================================================
   PDP Redesign – Leinenweberei Hoffmann
   Buy-Box-Logik: Variantenauflösung, Preis, Status-Box, Lieferdatum,
   Naht-Hinweis, Größenberater, Sondermaß-Toggle, mobile Umsortierung,
   Kennzeichnung nicht lieferbarer Optionen, Ausverkauft-Zustand.
   Läuft ergänzend zur Theme-eigenen <product-variants>-Logik.
   ========================================================================== */
(function () {
  'use strict';

  function formatMoney(cents) {
    var euros = cents / 100;
    if (cents % 100 === 0) {
      return euros.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' €';
    }
    return euros.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' €';
  }

  /* HOFFMANN 03.09.2026: Optik der nicht lieferbaren Optionen.
     Uebernommen aus Focals eigenem theme.css (.color-swatch.is-disabled bzw.
     .block-swatch.is-disabled), damit es wieder genauso aussieht wie vor dem
     Umbau der Buy-Box: Text auf halbe Deckkraft, dazu ein Diagonalstrich.
     Die Variablen --background, --text-color und --border-color stammen aus
     dem Theme.

     Dazu der Ausverkauft-Zustand des Warenkorb-Buttons: gesperrte Optik, und
     der Preis wird ausgeblendet - neben "Ausverkauft" wirkt ein Betrag nur
     verwirrend. Das kurze Button-Label (mobil) wird durch das lange ersetzt,
     damit dort ebenfalls "Ausverkauft" steht und nicht "In den Warenkorb".
     Die Lieferzeile traegt display:flex aus dem Section-CSS, deshalb braucht
     ihr hidden-Attribut hier eine eigene Regel. */
  function injectAvailabilityStyle() {
    if (document.getElementById('pdp-availability-style')) return;
    var st = document.createElement('style');
    st.id = 'pdp-availability-style';
    st.textContent =
      '.pdp-color-swatch.is-unavailable > label{position:relative;opacity:.6}' +
      '.pdp-color-swatch.is-unavailable > label:after{content:"";position:absolute;top:0;right:0;bottom:0;left:0;border-radius:inherit;' +
      'background:linear-gradient(to bottom right,transparent calc(50% - 1px),rgb(var(--background)) calc(50% - 1px),rgb(var(--background)) calc(50% + 1px),transparent calc(50% + 1px))}' +
      '.pdp-chip.is-unavailable > label{color:rgba(var(--text-color),.5);' +
      'background-image:linear-gradient(to bottom right,transparent calc(50% - 1px),rgb(var(--border-color)) 50%,transparent calc(50% + 1px));' +
      'background-repeat:no-repeat}' +
      '[data-product-add-to-cart-button].is-sold-out{opacity:.55;cursor:not-allowed}' +
      '[data-product-add-to-cart-button].is-sold-out .pdp-atc-price{display:none}' +
      '[data-product-add-to-cart-button].is-sold-out .pdp-atc-label--short{display:none}' +
      '[data-product-add-to-cart-button].is-sold-out .pdp-atc-label--long{display:inline}' +
      '.pdp-delivery[hidden]{display:none !important}';
    document.head.appendChild(st);
  }

  function init(root) {
    if (!root || root.dataset.pdpInit) return;
    root.dataset.pdpInit = '1';

    var config;
    try {
      config = JSON.parse(root.querySelector('[data-pdp-config]').textContent);
    } catch (e) {
      return;
    }
    var variants = config.variants || [];
    var optionCount = config.optionCount || 1;
    var standardValues = config.standardValues || [];
    var seamThreshold = config.seamThreshold || 160;
    var customOnly = !!config.customOnly;

    var formId = config.formId;
    var priceEl = root.querySelector('[data-pdp-price]');
    var compareEl = root.querySelector('[data-pdp-compare]');
    var badgeEl = root.querySelector('[data-pdp-badge]');
    var totalEl = root.querySelector('[data-pdp-total]');
    var atcCompareEl = root.querySelector('[data-pdp-atc-compare]');
    var savingsEl = root.querySelector('[data-pdp-savings]');
    var statusCustom = root.querySelector('[data-pdp-status-custom]');
    var ctaButton = root.querySelector('[data-product-add-to-cart-button]');
    var ctaLabelEl = root.querySelector('[data-pdp-cta-label]');
    var deliveryEl = root.querySelector('[data-pdp-delivery-date]');
    var deliveryRow = deliveryEl ? deliveryEl.closest('.pdp-delivery') : null;
    var seamEl = root.querySelector('[data-pdp-seam]');
    var seamTextEl = root.querySelector('[data-pdp-seam-text]');
    var qtyInput = document.querySelector('input[name="quantity"][form="' + formId + '"]') ||
      root.querySelector('input[name="quantity"]');

    injectAvailabilityStyle();

    /* HOFFMANN 03.09.2026: Focals ProductVariants._updateDisableSelectors in
       theme.js baut seinen Selektor fest verdrahtet aus .color-swatch bzw.
       .block-swatch zusammen. Unsere Buy-Box benutzt .pdp-color-swatch und
       .pdp-chip, querySelector liefert deshalb null und die Methode bricht mit
       einem TypeError beim ersten Optionswert ab - seit dem Umbau wurde
       dadurch auf keinem Produkt mehr etwas als nicht lieferbar markiert. Wir
       kapseln den Aufruf, damit der Fehler die uebrige Theme-Logik nicht mehr
       stoert, und uebernehmen die Kennzeichnung unten selbst. */
    var pvEl = root.querySelector('product-variants');
    if (pvEl && typeof pvEl._updateDisableSelectors === 'function') {
      var origDisable = pvEl._updateDisableSelectors.bind(pvEl);
      pvEl._updateDisableSelectors = function () {
        try { origDisable(); } catch (err) {}
      };
    }

    /* ---------- Lieferdatum ---------- */
    if (deliveryEl) {
      var days = parseInt(deliveryEl.getAttribute('data-days'), 10) || 16;
      var d = new Date();
      d.setDate(d.getDate() + days);
      deliveryEl.textContent = d.toLocaleDateString('de-DE', { day: 'numeric', month: 'long' });
    }

    /* ---------- Optionswerte lesen ---------- */
    function selectedOptions() {
      var opts = [];
      for (var i = 1; i <= optionCount; i++) {
        var checked = root.querySelector('input[name="option' + i + '"]:checked');
        if (checked) {
          opts[i - 1] = checked.value;
          continue;
        }
        var sel = root.querySelector('select[name="option' + i + '"]');
        opts[i - 1] = sel ? sel.value : null;
      }
      return opts;
    }

    function findVariant(opts) {
      for (var v = 0; v < variants.length; v++) {
        var match = true;
        for (var i = 0; i < optionCount; i++) {
          if (opts[i] !== null && variants[v].options[i] !== opts[i]) { match = false; break; }
        }
        if (match) return variants[v];
      }
      return null;
    }

    /* ---------- Nicht lieferbare Optionen ----------
       Gleiche Kaskade wie Focal: fuer Option i zaehlen die Optionen davor in
       ihrer aktuellen Auswahl, die Optionen danach werden ignoriert. Farbe ist
       also durchgestrichen, wenn es in keiner Groesse eine lieferbare Variante
       gibt; eine Groesse ist durchgestrichen, wenn sie in der gerade gewaehlten
       Farbe nicht lieferbar ist. */
    function optionAvailable(index, value, opts) {
      for (var v = 0; v < variants.length; v++) {
        if (!variants[v].available) continue;
        if (variants[v].options[index] !== value) continue;
        var ok = true;
        for (var o = 0; o < index; o++) {
          if (opts[o] !== null && variants[v].options[o] !== opts[o]) { ok = false; break; }
        }
        if (ok) return true;
      }
      return false;
    }

    function updateAvailability() {
      var opts = selectedOptions();
      for (var i = 0; i < optionCount; i++) {
        var inputs = root.querySelectorAll('input[name="option' + (i + 1) + '"]');
        for (var k = 0; k < inputs.length; k++) {
          var host = inputs[k].closest('.pdp-color-swatch, .pdp-chip');
          if (!host) continue;
          host.classList.toggle('is-unavailable', !optionAvailable(i, inputs[k].value, opts));
        }
      }
    }

    function parseWidth(value) {
      var m = /(\d+)\s*[x×]/.exec(value || '');
      return m ? parseInt(m[1], 10) : null;
    }

    function isStandardSelection(opts) {
      if (customOnly) return false;
      if (!standardValues.length) return true;
      var sizePositions = config.sizePositions || [];
      for (var i = 0; i < sizePositions.length; i++) {
        var val = opts[sizePositions[i] - 1];
        if (val && standardValues.indexOf(val) === -1) return false;
      }
      return true;
    }

    /* ---------- Formular, an dem Focals <product-media> haengt ---------- */
    /* HOFFMANN 02.09.2026: Focals ProductMedia (theme.js) registriert seinen Listener mit
       document.getElementById(<form-id>)?.addEventListener('variant:changed', ...).
       Ein Dispatch auf document erreicht diesen Listener nie. Deshalb geht das Event
       unten an genau dieses Formular und traegt die Medien-ID als Objekt mit. Wegen
       bubbles: true erreicht es von dort weiterhin alle document-Listener (u. a. das
       Color-Cascading in assets/custom.js); das dort ausgewertete event.target ist
       jetzt zusaetzlich korrekt das Formular.

       HOFFMANN 03.09.2026: Das Umschalten der Galerie uebernimmt jetzt komplett
       assets/hoffmann-media-groups.js anhand der Bildgruppen. Der fruehere
       Direktaufruf mediaCarousel.select(...) an dieser Stelle ist entfallen: er
       sprang bei JEDEM Variantenwechsel auf das Varianten-Thumbnail zurueck, also
       auch beim blossen Groessenwechsel innerhalb derselben Farbe, und lief
       ausserdem gegen die Flickity-Instanz, die der Gruppenwechsel gerade neu
       aufbaut. */
    var mediaEl = root.querySelector('product-media');
    var variantForm = mediaEl ? document.getElementById(mediaEl.getAttribute('form-id')) : null;

    /* ---------- Anzeige aktualisieren ---------- */
    function update() {
      var opts = selectedOptions();
      var variant = findVariant(opts);
      var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;

      updateAvailability();

      /* HOFFMANN 03.09.2026: available ist genau dann false, wenn der Bestand
         aufgebraucht ist UND "Weiterverkauf zulassen" ausgeschaltet ist. Das
         ist damit die bewusste Aussage "wird nicht mehr produziert" - der
         Button wird gesperrt, statt den Kunden erst im Warenkorb in eine
         Fehlermeldung laufen zu lassen. */
      var soldOut = !!variant && variant.available === false;

      if (variant) {
        /* HOFFMANN-PATCH 06.07.2026: Theme-eigenes <product-variants> dispatcht
           'variant:changed' auf dieser Seite nicht zuverlässig (die Buy-Box
           hier hat kein <product-meta>/<product-payment-container>, an denen
           die Theme-Logik das Event normalerweise festmacht). custom.js's
           Color-Cascading ("Passend dazu" + Quick-View-Vorauswahl) hört exakt
           auf dieses Event – also dispatchen wir es hier selbst, sobald pdp.js
           eine neue Variante aufgelöst hat. Nur bei echtem Varianten-Wechsel
           (nicht bei jedem Mengen-Update), daher der Vergleich mit der zuletzt
           dispatchten Variante. */
        if (root.dataset.pdpLastVariant !== String(variant.id)) {
          root.dataset.pdpLastVariant = String(variant.id);
          (variantForm || document).dispatchEvent(new CustomEvent('variant:changed', {
            bubbles: true,
            detail: {
              variant: {
                id: variant.id,
                price: variant.price,
                compare_at_price: variant.compare_at_price,
                available: variant.available,
                options: variant.options,
                featured_media: variant.featured_media_id ? { id: variant.featured_media_id } : null,
                option1: variant.options[0] || null,
                option2: variant.options[1] || null,
                option3: variant.options[2] || null
              }
            }
          }));
        }

        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (compareEl) {
          compareEl.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
          compareEl.hidden = !onSale;
        }
        if (badgeEl) {
          if (onSale) {
            var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
            badgeEl.textContent = '−' + pct + ' %';
          }
          badgeEl.hidden = !onSale;
        }
        if (totalEl) totalEl.textContent = formatMoney(variant.price * qty);
        if (atcCompareEl) {
          atcCompareEl.textContent = onSale ? formatMoney(variant.compare_at_price * qty) : '';
          atcCompareEl.hidden = !onSale;
        }
        if (savingsEl) {
          if (onSale) {
            savingsEl.textContent = 'Sie sparen ' + formatMoney((variant.compare_at_price - variant.price) * qty) +
              ' gegenüber dem regulären Preis.';
          }
          savingsEl.hidden = !onSale;
        }

        /* Fallback: verstecktes id-Feld setzen, falls Theme-JS nicht greift */
        var form = document.getElementById(formId);
        if (form) {
          var idInput = form.querySelector('input[name="id"]');
          if (idInput) {
            idInput.value = variant.id;
            idInput.disabled = false;
          }
        }
      }

      /* Status-Box: HOFFMANN-PATCH 06.07.2026 – zeigt nur noch den
         Sonderanfertigungs-Hinweis, und zwar ausschließlich, wenn die
         aktuell aufgelöste Variante das Metafeld custom.customized = "1"
         hat (aus data-pdp-config eingebettet). Bei ausverkauften Varianten
         bleibt er aus - dort ist die Aussage "nicht mehr lieferbar" die
         wichtigere. */
      var isCustomizedVariant = customOnly || (!!variant && (variant.customized === '1' || variant.customized === 1));

      if (statusCustom) {
        statusCustom.hidden = !isCustomizedVariant || soldOut;
      }

      /* HOFFMANN 03.09.2026: Die Lieferzeile nennt ein konkretes Versanddatum.
         Bei einer ausverkauften Variante ist dieses Versprechen falsch - der
         Artikel kann gerade gar nicht bestellt werden. Also verschwindet die
         Zeile zusammen mit dem gesperrten Button. Sobald der dritte Zustand
         "In Auftrag geben" dazukommt, bekommt sie dort ihr eigenes, laengeres
         Datum aus dem Produktionszyklus. */
      if (deliveryRow) {
        deliveryRow.hidden = soldOut;
      }

      /* CTA-Text: HOFFMANN-PATCH 06.07.2026 – Button-Beschriftung wechselt
         synchron zur Sonderanfertigungs-Status-Box zwischen dem normalen
         CTA-Text ("In den Warenkorb") und dem Sonderanfertigungs-Text
         ("Für mich fertigen lassen"). HOFFMANN 03.09.2026: dritter Zustand
         "Ausverkauft" mit gesperrtem Button; Preis und kurzes Label blendet
         das CSS oben dann aus. */
      if (ctaButton) {
        var ctaDefault = ctaButton.getAttribute('data-pdp-cta-default') || '';
        var ctaCustom = ctaButton.getAttribute('data-pdp-cta-custom') || ctaDefault;
        var ctaSoldOut = ctaButton.getAttribute('data-pdp-cta-soldout') || 'Ausverkauft';
        var ctaLabel = soldOut ? ctaSoldOut : (isCustomizedVariant ? ctaCustom : ctaDefault);
        if (ctaLabelEl) ctaLabelEl.textContent = ctaLabel;
        var ctaPriceText = totalEl ? totalEl.textContent : (variant ? formatMoney(variant.price * qty) : '');
        ctaButton.setAttribute('data-button-content', soldOut ? ctaLabel : ctaLabel + ' · ' + ctaPriceText);
        ctaButton.disabled = soldOut;
        ctaButton.classList.toggle('is-sold-out', soldOut);
      }

      /* Naht-Hinweis */
      if (seamEl && seamTextEl) {
        var sizePositions = config.sizePositions || [];
        var sizeVal = sizePositions.length ? opts[sizePositions[0] - 1] : null;
        var width = parseWidth(sizeVal);
        if (width !== null) {
          seamEl.hidden = false;
          if (width >= seamThreshold || /seitlich angesetzt/i.test(sizeVal || '')) {
            seamTextEl.textContent = 'Bei dieser Breite wird die Stoffbahn seitlich angesetzt – die Naht liegt am Rand der Liegefläche, keine Mittelnaht.';
          } else {
            seamTextEl.textContent = 'Diese Breite fertigen wir aus einer durchgehenden Stoffbahn – ganz ohne Naht in der Liegefläche.';
          }
        } else {
          seamEl.hidden = true;
        }
      }

      /* Dropdown-Optionstexte mit Preisen anreichern (Maßanfertigung) */
      root.querySelectorAll('select[name^="option"][data-pdp-priced]').forEach(function (sel) {
        var pos = parseInt(sel.getAttribute('data-position'), 10);
        Array.prototype.forEach.call(sel.options, function (opt) {
          var test = opts.slice();
          test[pos - 1] = opt.value;
          var v = findVariant(test);
          var base = opt.getAttribute('data-label') || opt.value;
          opt.textContent = v ? base + ' – ' + formatMoney(v.price) : base;
        });
      });
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('input[name^="option"], select[name^="option"]')) update();
    });
    if (qtyInput) {
      qtyInput.addEventListener('change', update);
      var qtyWrap = qtyInput.closest('quantity-selector');
      if (qtyWrap) qtyWrap.addEventListener('click', function () { setTimeout(update, 0); });
    }

    /* ---------- Sondermaß-Toggle ---------- */
    root.querySelectorAll('[data-pdp-size-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = document.getElementById(btn.getAttribute('aria-controls'));
        if (!target) return;
        var open = target.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open
          ? '− Weitere Größen wieder einklappen'
          : btn.getAttribute('data-label-closed');
      });
    });

    /* ---------- Größenberater ---------- */
    var advisor = root.querySelector('[data-pdp-advisor]');
    if (advisor) {
      var lastFocus = null;
      function openAdvisor() {
        lastFocus = document.activeElement;
        advisor.classList.add('is-open');
        document.documentElement.style.overflow = 'hidden';
        var closeBtn = advisor.querySelector('.pdp-advisor__close');
        if (closeBtn) closeBtn.focus();
      }
      function closeAdvisor() {
        advisor.classList.remove('is-open');
        document.documentElement.style.overflow = '';
        if (lastFocus) lastFocus.focus();
      }
      root.querySelectorAll('[data-pdp-advisor-open]').forEach(function (btn) {
        btn.addEventListener('click', openAdvisor);
      });
      advisor.addEventListener('click', function (e) {
        if (e.target === advisor || e.target.closest('[data-pdp-advisor-close]')) closeAdvisor();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape' || !advisor.classList.contains('is-open')) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        closeAdvisor();
      });
    }

    /* ---------- Matratzenhöhe: Pflichtfeld ----------
       Seit 17.09.2026 ist das Feld Pflicht, sobald es erscheint. Geprueft wird
       nicht mehr nur auf leer, sondern auch auf den zulaessigen Bereich, und
       der Waechter haengt in der Capture-Phase am Dokument: Focals
       product-form faengt das Absenden selbst ab und schickt es per fetch
       weiter, ein Zuhoerer am Formular kaeme dafuer zu spaet.
       Rot wird das Feld erst nach einem Versuch, nicht schon beim Seitenaufruf. */
    var heightInput = root.querySelector('[data-pdp-height]');
    if (heightInput) {
      heightInput.addEventListener('input', function () {
        var clean = String(heightInput.value).replace(/[^0-9]/g, '').slice(0, 2);
        if (clean !== heightInput.value) heightInput.value = clean;
        if (clean !== '') heightInput.classList.remove('is-empty');
      });

      document.addEventListener('submit', function (e) {
        var form = e.target;
        if (!form || form.id !== formId) return;
        if (!heightInput.required || heightInput.disabled) return;
        var raw = String(heightInput.value).replace(/[^0-9]/g, '');
        var num = parseInt(raw, 10);
        var min = parseInt(heightInput.getAttribute('min'), 10) || 1;
        var max = parseInt(heightInput.getAttribute('max'), 10) || 999;
        if (raw !== '' && !isNaN(num) && num >= min && num <= max) return;
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        heightInput.classList.add('is-empty');
        try { heightInput.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (err) {}
        heightInput.focus();
        if (heightInput.reportValidity) heightInput.reportValidity();
      }, true);
    }

    /* ---------- Mobile Umsortierung: Farbwahl direkt unter den Slider.
                  ("Passt dazu" mobil liefert die eigene Section mit desktop-hidden.) ---------- */
    var colorGroup = root.querySelector('[data-pdp-color-group]');
    var colorSlotMobile = root.querySelector('[data-pdp-color-slot-mobile]');
    var colorSlotDesktop = root.querySelector('[data-pdp-color-slot-desktop]');
    var mq = window.matchMedia('(max-width: 740px)');

    function relocate() {
      if (mq.matches) {
        if (colorGroup && colorSlotMobile && colorGroup.parentNode !== colorSlotMobile) {
          colorSlotMobile.appendChild(colorGroup);
          colorGroup.classList.add('pdp-color-group--relocated');
        }
      } else {
        if (colorGroup && colorSlotDesktop && colorGroup.parentNode !== colorSlotDesktop) {
          colorSlotDesktop.appendChild(colorGroup);
          colorGroup.classList.remove('pdp-color-group--relocated');
        }
      }
    }
    if (colorGroup) {
      relocate();
      if (mq.addEventListener) mq.addEventListener('change', relocate);
      else if (mq.addListener) mq.addListener(relocate);
    }

    update();
  }

  function initAccordions(scope) {
    (scope || document).querySelectorAll('[data-pdp-accordion-toggle]').forEach(function (btn) {
      if (btn.dataset.pdpBound) return;
      btn.dataset.pdpBound = '1';
      btn.addEventListener('click', function () {
        var content = document.getElementById(btn.getAttribute('aria-controls'));
        if (!content) return;
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        content.hidden = expanded;
        if (!expanded) content.classList.add('pdp-fade-in');
        var icon = btn.querySelector('.pdp-accordion__icon');
        if (icon) icon.textContent = expanded ? '+' : '−';
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-pdp-main]').forEach(init);
    initAccordions(document);
  }

  /* Flickity-Galerie nach vollständigem Layout neu vermessen (Safari misst sonst
     die Slider-Zellen vor dem Grid-Layout und die Galerie ragt in die Buy-Box). */
  function kickResize() {
    window.dispatchEvent(new Event('resize'));
  }
  window.addEventListener('load', function () {
    kickResize();
    setTimeout(kickResize, 250);
    setTimeout(kickResize, 1000);
  });

  /* HOFFMANN 27.07.2026: Neumessung direkt beim Aktivwerden des Sliders.
     Gemessen wurde, dass Flickity die Buehne beim Initialisieren auf 0x0
     vermisst, wenn das Layout noch nicht steht: Slider aktiv bei 793 ms,
     Buehne leer von 833 bis 1234 ms, dabei item 0x0, img 0x0 und ein
     Viewport von 0 px, obwohl das Hauptbild eager geladen und fertig war.
     Repariert wurde das bisher erst durch das kickResize oben, das an
     window.load haengt und damit rund 400 ms zu spaet kommt. Die Neumessung
     laeuft jetzt zusaetzlich in dem Moment, in dem die Klasse
     flickity-enabled gesetzt wird, plus zwei kurze Nachfassversuche fuer
     den Fall, dass im ersten Frame noch Schriften oder Bilder einlaufen. */
  function watchGalleryInit() {
    var carousel = document.querySelector('.pdp-hero__gallery flickity-carousel.product__media-list');
    if (!carousel || typeof MutationObserver !== 'function') return;
    if (carousel.className.indexOf('flickity-enabled') > -1) { kickResize(); return; }
    var observer = new MutationObserver(function () {
      if (carousel.className.indexOf('flickity-enabled') === -1) return;
      observer.disconnect();
      kickResize();
      if (typeof requestAnimationFrame === 'function') requestAnimationFrame(kickResize);
      setTimeout(kickResize, 80);
      setTimeout(kickResize, 240);
    });
    observer.observe(carousel, { attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchGalleryInit);
  } else {
    watchGalleryInit();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
